<div class="pl-pane__container--horizontal">

  <div class="x-my-schedule-header pl-pane--collapse pl-pane--shrink pl-pane--sticky-top">
    <div class="pl-page-header pl-pane">
      <div pl-grid="tight spaced align-middle">
        <div pl-grid-el pl-grid="shrink@phone">
          <h1 class="pl-heading--xlarge" [textContent]="'SCHEDULE.title' | translate">upcomin evnts</h1>
        </div>
        <div pl-grid-el pl-grid="shrink@phone">
          <se-fe-button (click)="syncCalendar()" [seFeDataEmphasis]="'low'">Sync Schedule</se-fe-button>
        </div>
      </div>
    </div>
  </div>

  <section
    [ngClass]="{'myse-infinite-scroll--ready': loaded}"
    class="pl-pane__info js-schedule-scroll myse-infinite-scroll">

    <div class="pl-centered-container--max-width-medium">
      <div pl-grid="tight@tablet" class="js-event-container">
        <!-- skeleton -->
        @if (!loaded) {
          <div pl-grid-el pl-grid="1/1@phone">
            <div class="myse-dashboard-skeleton--section-card myse-dashboard__full-card se-card"></div>
          </div>
        }
        @if (!loaded) {
          <div pl-grid-el pl-grid="1/1@phone">
            <div class="myse-dashboard-skeleton--section-card myse-dashboard__full-card se-card"></div>
          </div>
        }
        @if (!loaded) {
          <div pl-grid-el pl-grid="1/1@phone">
            <div class="myse-dashboard-skeleton--section-card myse-dashboard__full-card se-card"></div>
          </div>
        }
        @if (loaded && !(isFirstPage && isLastPage)) {
          <div pl-grid="loose"
            class="pl-text--right"
            style="margin-bottom: 8px">
            <div pl-grid-el pl-grid="1/1@phone">
              @if (events.length > 0) {
                <span class="pl-text--light"
              [textContent]="'SCHEDULE.paginate_label' | translate: {
                amount: events.length,
                start: firstDay() | date: 'MMM d',
                end: lastDay() | date: 'MMM d'
              }">
                </span>
              }
              &nbsp;
              <span>
                <se-fe-icon-button [seFeDataIsDisabled]="isFirstPage" (click)="previousPage()">
                  <se-fe-icon
                    seFeDataName="chevron_left"
                    seFeDataSize="700"
                    seFeDataAriaLabel="'PAGINATION.previous' | translate"
                    seFeDataMargin="false">
                  </se-fe-icon>
                </se-fe-icon-button>
                <se-fe-icon-button [seFeDataIsDisabled]="isLastPage" (click)="nextPage()">
                  <se-fe-icon
                    seFeDataName="chevron_right"
                    seFeDataSize="700"
                    seFeDataAriaLabel="'PAGINATION.next' | translate"
                    seFeDataMargin="false">
                  </se-fe-icon>
                </se-fe-icon-button>
              </span>
            </div>
          </div>
        }

        <!-- sliding window of events -->
        @if (loaded) {
          @for (day of days; track day; let isLast = $last) {
            <div
              pl-grid-el
              pl-grid="1/1@phone"
              class="myse-event__day-container">
              <div class="myse-event__day-label">
                <app-date-stamp [dateString]="day.day"></app-date-stamp>
              </div>
              <div class="myse-event__day-grouping">
                @for (event of day.events; track event) {
                  <div
                    class="event-class-for-event">
                    @if (event.emptyMessage) {
                      <se-fe-empty-state seFeDataTitle="{{ event.emptyMessage }}">
                      </se-fe-empty-state>
                    }
                    @if (!event.emptyMessage) {
                      <app-event-card [dataEvent]="event" (onRsvp)="onRsvp($event)"></app-event-card>
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>

      @if (isLastPage && loaded) {
        <div pl-grid="loose">
          <div pl-grid-el pl-grid="1/1@phone" class="myse-infinite-scroll__empty-state">
            <se-fe-empty-state seFeDataTitle="{{ 'SCHEDULE.no_more_events_title' | translate }}" seFeDataSize="500">
              {{ 'SCHEDULE.no_more_events_description' | translate }}
            </se-fe-empty-state>
          </div>
        </div>
      }
      @if (loaded && !(isFirstPage && isLastPage)) {
        <div pl-grid="loose" class="pl-text--right">
          <div pl-grid-el pl-grid="1/1@phone">
            @if (events.length > 0) {
              <span class="pl-text--light"
            [textContent]="'SCHEDULE.paginate_label' | translate: {
              amount: events.length,
              start: firstDay() | date: 'MMM d',
              end: lastDay() | date: 'MMM d'
            }">
              </span>
            }
            &nbsp;
            <span>
              <se-fe-icon-button [seFeDataIsDisabled]="isFirstPage" (click)="previousPage()">
                <se-fe-icon
                  seFeDataName="chevron_left"
                  seFeDataSize="700"
                  seFeDataAriaLabel="'PAGINATION.previous' | translate"
                  seFeDataMargin="false">
                </se-fe-icon>
              </se-fe-icon-button>
              <se-fe-icon-button [seFeDataIsDisabled]="isLastPage" (click)="nextPage()">
                <se-fe-icon
                  seFeDataName="chevron_right"
                  seFeDataSize="700"
                  seFeDataAriaLabel="'PAGINATION.next' | translate"
                  seFeDataMargin="false">
                </se-fe-icon>
              </se-fe-icon-button>
            </span>
          </div>
        </div>
      }
    </div>
  </section>
</div>
